import axios from "axios";

//state
export var setState = {
  set: {},
  sets: [],
  status_sets: ""
};

//getters
export var setGetters = {
  //funciones para optener informacion del state
  getSet: state => state.set,
  getSets: state => state.sets
};

//actions
export var setAcctions = {
  async getSet({ commit }) {
    commit("set_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        const set = {
          id: 2,
          nombre: "Apache navidad",
          creada: "2012/01/01",
          acciones: {
            disponible: true,
            editar: true,
            eliminar: true
          },
          status: "Active"
        };
        commit("set_success", set);
        return set;
      })
      .catch(err => {
        commit("set_error");
        return err;
      });
  },
  async getSets({ commit }) {
    commit("set_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        const sets = [
          {
            id: 2,
            nombre: "Apache navidad",
            creada: "2012/01/01",
            acciones: {
              disponible: true,
              editar: true,
              eliminar: true
            },
            status: "Active"
          },
          {
            id: 3,
            nombre: "Educación para adolescentes",
            creada: "2012/02/01",
            acciones: {
              disponible: false,
              editar: false,
              eliminar: true
            },
            status: "Banned"
          },
          {
            id: 4,
            nombre: "Software a la medida",
            creada: "2012/02/01",
            acciones: {
              disponible: true,
              editar: true,
              eliminar: true
            },
            status: "Inactive"
          },
          {
            id: 5,
            nombre: "Apps development",
            acciones: {
              disponible: true,
              editar: true,
              eliminar: true
            },
            status: "Pending"
          },
          {
            id: 6,
            nombre: "Viernes negro",
            acciones: {
              disponible: false,
              editar: false,
              eliminar: true
            },
            status: "Active"
          },
          {
            id: 7,
            nombre: "Ofertas",
            creada: "2012/01/01",
            acciones: {
              disponible: true,
              editar: true,
              eliminar: true
            },
            status: "Active"
          },
          {
            id: 8,
            nombre: "Jugadores de futbol",
            creada: "2012/02/01",
            acciones: {
              disponible: false,
              editar: false,
              eliminar: true
            },
            status: "Banned"
          }
        ];
        commit("sets_success", sets);
        return sets;
      })
      .catch(err => {
        commit("set_error");
        return err;
      });
  },
  async newSet({ commit, state }, set) {
    commit("set_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        var sets = state.sets;
        sets.push(set);
        commit("sets_success", sets);
        return sets;
      })
      .catch(err => {
        commit("set_error");
        return err;
      });
  },
  async editSet({ commit, state }, set) {
    commit("set_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        var sets = state.sets;
        var index = sets.findIndex(element => {
          return element.id == set.id;
        });
        sets.splice(index, 1);
        sets.splice(index, 0, set);
        commit("sets_success", sets);
        return sets;
      })
      .catch(err => {
        commit("set_error");
        return err;
      });
  },
  async deleteSet({ commit, state }, id) {
    commit("set_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        var sets = state.sets;
        var index = sets.findIndex(element => {
          return element.id == id;
        });
        sets.splice(index, 1);
        commit("sets_success", sets);
        return sets;
      })
      .catch(err => {
        commit("set_error");
        return err;
      });
  }
};

//mutations

export var setMutations = {
  set_request(state) {
    state.status_sets = "loading";
  },
  set_success(state, payload) {
    state.status_sets = "success";
    state.set = payload;
  },
  sets_success(state, payload) {
    state.status_sets = "success";
    state.sets = payload;
  },
  set_error(state) {
    state.status_sets = "error";
  }
};
